import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { SitesTable } from "@/features/sites/components/SitesTable"

/**
 * Sahalar sayfası (2026-04-22) — Site entity listesi: saha sahibi, partner,
 * cihaz sayısı, lokasyon. `/api/SuperAdmin/sites` (owner+partner enriched).
 * 2026-04-24 — `?id=<guid>` deep-link: URL paramı → saha detay drawer otomatik açılır.
 */
const searchSchema = z.object({ id: z.string().optional() })

export const Route = createFileRoute("/_authed/sites")({
  component: SitesPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function SitesPage() {
  const { t } = useTranslation("sites")
  const { id } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <SitesTable initialSelectedId={id ?? null} />
    </div>
  )
}
